import {DspFluxExportCard} from './DspFluxExportCard'
import {MergeReportsCard} from './MergeReportsCard'
import {StyledCardsRow} from './style'

// Operational cards shown directly under the page header: enqueue the merged (domiciliary +
// outpatient) report and extract the DSP Flux archive — both without selecting any table row.
export const ActivityReportExportCards = () => (
    <StyledCardsRow>
        <MergeReportsCard />
        <DspFluxExportCard />
    </StyledCardsRow>
)
